<template>
  <div class="project-rate">
    <DialogSlot
      :id="dialogId"
      ref="rating-modal"
      :modalBtnClass="'btn--transparent'"
      :modalBtn="actionName"
      :afterOpenModal="getRate"
    >
      <div
        slot="content"
        class="slot-content"
      >
        <div class="project-review-title">
          {{ $t('hint.projectReview') }}
        </div>
        <div
          v-if="isProjectCompleteRate"
          class="project-rate-hint"
        >
          {{ $t('hint.completeProject') }}
        </div>
        <div class="project-rate-hint">
          {{ $t('project.rate.rateHint') }}
        </div>
        <template v-for="(facade, index) in rateFacades">
          <div
            :key="`rate-category-${index}`"
            class="rate-category"
          >
            {{ $t(`project.rate.${facade.hint}`) }}
          </div>
          <ul
            :key="`rate-face-list-${index}`"
            class="rate-face-list"
          >
            <template v-for="(item, itemIndex) in rateValues">
              <li
                :key="itemIndex"
                :class="item.class"
              >
                <input
                  :id="dialogId + facade.code + item.code"
                  v-model="facade.modelValue"
                  type="radio"
                  :name="facade.name"
                  :value="item.value"
                >
                <label :for="dialogId + facade.code + item.code">
                  <img
                    class="rate-face"
                    :src="item.srcImg"
                    :alt="item.value"
                  >
                </label>
              </li>
            </template>
          </ul>
        </template>
        <div class="rate-category">
          {{ $t('project.rate.comments') }}
        </div>
        <TextField
          v-if="allowEdit"
          :value="remark"
          @updateValue="val => updateRemarkValue(val)"
        />
        <div v-if="!allowEdit">
          <pre>{{ remark }}</pre>
        </div>
      </div>
      <div
        v-if="allowEdit"
        slot="buttons"
      >
        <button
          v-hkldreset
          type="button"
          class="btn btn--orange close-reveal-modal"
          @click="rateProject()"
        >{{ $t('action.ok') }}</button>
      </div>
    </DialogSlot>
  </div>
</template>

<script>
import EventBus from '@/utils/eventBus'
import { mapGetters, mapActions } from 'vuex'
import { rateActionType, rateType } from '@/utils/locale'
import * as ratesApi from '@/api/rates/request'
import DialogSlot from '@/controls/DialogSlot'
import TextField from '@/controls/TextField'
import { ActionTypes } from '@/utils/consts'
import i18n from '@/utils/i18n'
import notification from '@/utils/notification'

export default {
  name: 'ProjectRate',
  components: {
    DialogSlot,
    TextField,
  },
  props: {
    rateType: {
      type: String,
    },
    dialogId: {
      type: String,
    },
    actionType: {
      type: String,
    },
    sourceId: {
      type: String,
    },
    allowEdit: {
      type: Boolean,
      default: true,
    },
  },
  data () {
    return {
      rateFacades: [
        { code: 'designPlanningDocumentation', name: 'designPlanningDocumentation', modelValue: ' ', hint: 'designPlanningDocumentation' },
        { code: 'siteManagementCooperation', name: 'siteManagementCooperation', modelValue: ' ', hint: 'siteManagementCooperation' },
        { code: 'workQuality', name: 'workQuality', modelValue: ' ', hint: 'workQuality' },
        { code: 'timelyServiceFollowUp', name: 'timelyServiceFollowUp', modelValue: ' ', hint: 'timelyServiceFollowUp' },
        { code: 'safetyTidinessCleanliness', name: 'safetyTidinessCleanliness', modelValue: ' ', hint: 'safetyEnvrionmental' }],
      rateValues: [
        { code: 'Sadness', value: 'Sadness', srcImg: '/sad-face.svg', class: 'sadness' },
        { code: 'Expressionless', value: 'Expressionless', srcImg: '/expressionless-face.svg' },
        { code: 'Smile', value: 'Smile', srcImg: '/smile-face.svg' },
        { code: 'Laugh', value: 'Laugh', srcImg: '/laugh-face.svg' }],
      remark: '',
      rate: {},
      isNew: true,
    }
  },
  methods: {
    ...mapActions('projects', ['updateProject', 'loadProject', 'updateProjectStatus']),

    updateRemarkValue (val) {
      this.remark = val
    },

    async rateProject () {
      let isEmptyField = false
      let isSadnessExisting = false
      this.rateFacades.forEach((item) => {
        if (item.modelValue === ' ') {
          isEmptyField = true
        } else if (item.modelValue === 'Sadness') {
          isSadnessExisting = true
        }
      })
      if (isEmptyField) {
        notification.fireNotification(false, this.$i18n.t('project.rate.emptyFieldAlert'))
        return false
      }
      if (isSadnessExisting && !this.remark) {
        notification.fireNotification(false, this.$i18n.t('project.rate.emptyRemarkAlert'))
        return false
      }
      const rate = {}
      this.rateFacades.forEach((item) => {
        rate[item.code] = item.modelValue
      })
      rate['remark'] = this.remark
      rate['type'] = this.rateType
      this.rate = rate
      const request = {
        sourceId: this.sourceId,
        rate: this.rate,
      }
      let action
      switch (this.actionType) {
        case rateActionType.WORK_COMPLETED:
          action = this.isNew ? ActionTypes.rates.complete.create : ActionTypes.rates.complete.update
          break
        case rateActionType.RETENTION_RECEIVED:
          action = this.isNew ? ActionTypes.rates.retention.create : ActionTypes.rates.retention.update
          break
      }
      const isNeedToUpdateSR = [rateType.WORK_COMPLETED, rateType.RETENTION_RECEIVED].includes(this.rateType)
      if (this.isNew) {
        await ratesApi.createRates(request, action, !isNeedToUpdateSR)
      } else {
        await ratesApi.updateRates(request, action, !isNeedToUpdateSR)
      }
      this.rateFacades.forEach((item) => {
        item.modelValue === ' '
      })
      if (isNeedToUpdateSR) {
        EventBus.emit(`rate_or_final_modal_update_submission_${this.dialogId}`)
      }
      await this.loadProject(this.currentProject.id)
      this.$refs['rating-modal'].closeModal()
    },
    async getRate () {
      let rates = []
      rates = await ratesApi.getRates(this.sourceId)
      this.rate = rates[rates.length - 1]
      if (this.rate) {
        this.isNew = false
        this.rateFacades.forEach((item) => {
          item.modelValue = this.rate[item.code]
        })
        this.rateType = this.rate.type
        this.remark = this.rate.remark
      }
    },
    async init () {
      this.$refs['rating-modal'].openModal()
    },
  },
  computed: {
    ...mapGetters('user', ['currentUser']),
    ...mapGetters('projects', ['currentProject']),
    actionName () {
      if (this.actionType === rateActionType.PROJECT_COMPLETED) {
        return i18n.t('action.complete')
      } else {
        return i18n.t('action.rate')
      }
    },
    isProjectCompleteRate () {
      if (this.actionType === rateActionType.PROJECT_COMPLETED) {
        return true
      }
      return false
    },
  },
}
</script>

<style lang="scss" scoped>
ul.rate-face-list {
  margin-top: 0em;
  margin-bottom: 0.5em;
  list-style: none;
  margin-left: 0;
  li {
    display: inline-block;
    margin-right: 0px;
    margin-left: 0px;
  }
  input {
    visibility:hidden;
    display:none;
  }
  label {
    margin-right: 0px;
    margin-left: 0px;
    cursor: pointer;
  }
  li.sadness {
    input:checked + label {
      img {
        background: #ff1a1a;
        border-radius: 2em;
      }
    }
  }
  input:checked + label {
    img {
      background: #ffcc00;
      border-radius: 2em;
    }
  }
}

.project-review-title, .project-rate-hint {
  font-family: Georgia;
  font-size: 24px;
  font-style: italic;
  color: #0c3a58;
  margin-bottom: 15px;
}
.project-rate-hint {
  font-size: 18px;
}

.rate-category {
  font-family: Georgia;
  font-size: 16px;
  font-style: normal;
}

.rate-face {
  margin-right: 5px;
}
</style>
